import BaseService from './BaseService'

class UserService extends BaseService {
  constructor() {
    super('')  // Remove the /users base path since we're using /profile directly
  }

  // Add user-specific methods
  async login(credentials) {
    return this.customRequest('post', '/auth/login', credentials)
  }

  async register(userData) {
    return this.customRequest('post', '/auth/register', userData)
  }

  async getProfile() {
    return this.customRequest('get', '/profile')
  }

  async updateProfile(data) {
    return this.customRequest('put', '/profile', data)
  }

  async updateProfilePicture(formData) {
    return this.customRequest('post', '/picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export const userService = new UserService()
